import React from "react";

function Footer() {
  return (
    <div className="inner-wrapper">
      <div className="content">
        <p className="p-2 m-0">
          MARKUSHALL.DE © 2004-2026 | JOSUA HALL | info@markushall.de
        </p>
      </div>
    </div>
  );
}

export default Footer;
